const webPageSchema = ({
  url,
  title,
  description,
  image,
  pageType = "WebPage",
}) => ({
  "@context": "https://schema.org",
  "@type": pageType,

  "@id": `${url}#webpage`,
  url,
  name: title,
  description,

  isPartOf: {
    "@id": "https://irisimpulse.com/#website",
  },

  about: {
    "@id": "https://irisimpulse.com/#organization",
  },

  ...(image && {
    primaryImageOfPage: {
      "@type": "ImageObject",
      url: image,
    },
  }),

  inLanguage: "en",
});

export default webPageSchema;
